// ============================================================
// LegalFooter.js
// Persistent global footer with links to the public legal pages
// (privacy policy, terms of use, sub-processors).
//
// Plain <a href> tags, not React Router <Link>: the legal pages
// are static HTML at the SWA root, outside the React bundle, so
// the browser must perform a full navigation. Absolute URLs are
// used so the same component works on both a2zcarehub.co.uk and
// admin.a2zcarehub.co.uk without forking.
// ============================================================

import React from 'react';
import './LegalFooter.css';

export default function LegalFooter() {
  return (
    <footer className="legal-footer">
      <div className="legal-footer__inner">
        <nav className="legal-footer__links" aria-label="Legal">
          <a href="https://a2zcarehub.co.uk/privacy/">Privacy Policy</a>
          <span className="legal-footer__sep" aria-hidden="true">|</span>
          <a href="https://a2zcarehub.co.uk/terms/">Terms of Use</a>
          <span className="legal-footer__sep" aria-hidden="true">|</span>
          <a href="https://a2zcarehub.co.uk/sub-processors/">Sub-processors</a>
        </nav>
        <span className="legal-footer__copyright">© 2026 A2Z IT Limited</span>
      </div>
    </footer>
  );
}
